<template>
    <div class="module__edit_content">
        <component-system-uploader-scorm
            :value-data="moduleContentData"
            :disabled="isShowMode"
        ></component-system-uploader-scorm>
        <component-wrapper v-if="isAddMode || (isEditMode && moduleContent !== moduleDefaultContent)">
            <div class="module__edit_content_actions">
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :disabled="!moduleContent"
                            :name="`module-edit-content-action-save`"
                            :hint="moduleContent ? 'Please continue to the next section to add the module details.' : ''"
                            :align="'right'"
                            @click="moduleNextStep"
                        >
                            Save and continue
                        </component-button>
                    </div>
                </div>
            </div>
        </component-wrapper>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentSystemUploaderScorm from '@/components/default/shared/ComponentSystemUploaderSCORM'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'module-edit-content',
  components: { PopNotify, ComponentWrapper, ComponentSystemUploaderScorm, ComponentButton },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    moduleId () {
      return this.$store.getters.getEbsModuleId
    },
    moduleContent () {
      return this.$store.getters.getEbsModuleContent
    },
    moduleDefaultContent () {
      return this.$store.getters.getEbsModuleDefaultContent
    },
    moduleContentData () {
      return this.$store.getters.getEbsModuleCustomContentData
    },
    //
    rootItemName () {
      return 'module'
    },
    //
    watchContent () {
      return this.moduleContent
    },
    //
    isAddMode () {
      return this.$route.name.includes('module-add')
    },
    isEditMode () {
      return this.$route.name.includes('module-edit')
    },
    isShowMode () {
      return this.$route.name.includes('module-show')
    }
  },
  methods: {
    moduleNextStep () {
      let routeName
      let routeParams
      if (this.isEditMode) {
        routeName = 'ebs-module-edit-details'
        routeParams = { id: this.moduleId }
      } else {
        routeName = 'ebs-module-add-details'
        routeParams = ''
      }
      this.$router.push({ name: routeName, params: routeParams })
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleaddeditcontent";
</style>
